import React, { useState } from 'react'

export default function PhotoInput({imageUrl, error, onFileLoad}) {
  const [dragging, setDragging] = useState(false)
  const imgUrl = imageUrl && imageUrl.includes('data:') ? imageUrl : imageUrl + '?' + Math.random()

  const fileLoaded = (files) => {
    if (files && files[0]) onFileLoad(files[0])
  }

  const handleDrag = function(e) {
    e.preventDefault()
    e.stopPropagation()
    if (e.type === 'dragenter' || e.type === 'dragover') return setDragging(true)
    if (e.type === 'dragleave') return setDragging(false)
  }

  const handleDrop = function(e) {
    e.preventDefault()
    e.stopPropagation()
    setDragging(false)
    fileLoaded(e.dataTransfer.files)
  }

  return <div className='banner-image-form'>
    <input 
      type='file'
      accept='image/png'
      id='banner-image-input'
      onChange={(e) => fileLoaded(e.target.files)}
    />
    <label 
      id='banner-image-label'
      className={dragging ? 'active' : '' }
      htmlFor='banner-image-input'
      onDragEnter={handleDrag}
      onDragOver={handleDrag}
      onDragLeave={handleDrag}
      onDrop={handleDrop}
    >
      <img src='/images/leagues/path.svg' />
      <span className='upload-button'>Upload a file</span>
      <span>PNG up to 10MB</span>
      <span><b>or drag and drop</b></span>
    </label>
    <label className='banner-image-error'>{ error && <div className='error_container'>{error.message}</div> }</label>
    { imageUrl &&
      <div className='photo-preview'>
        <img alt='Icon' src={imgUrl} />
      </div>
    }
  </div>
}
